module.exports = __webpack_public_path__ + "img/7.41cbcbd0.png";